import React from "react";
import styles from "./PatternBackground.module.less";

export default function PatternBackground(props: { children: React.ReactNode; overflow?: boolean }) {
    return (
        <div
            className={[
                styles.PatternBackground,
                props.overflow ? styles["PatternBackground--withOverflow"] : null
            ].join(" ")}
        >
            {props.children}
        </div>
    );
}
